// extracted by mini-css-extract-plugin
module.exports = {"formContainer":"ReportForm_formContainer__1kWBT","reportTable":"ReportForm_reportTable__2nIDi","onSubmit":"ReportForm_onSubmit__1UUwr"};